import { gql } from '@apollo/client';
const REMOVE_ORDER_MODELS = gql `
  mutation RemoveOrderModels($orderModelIds: [ID!]) {
    removeOrderModelNodes(orderModelIds: $orderModelIds) {
      removed
    }
  }
`;
export default REMOVE_ORDER_MODELS;
